import { Actions } from './discount-groups.actions'
import { fromJS } from 'immutable'
import * as DiscountGroupsTypes from './discount-groups.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 10,
    },
    total: 0,
    results: 0,
  },
  createDiscountGroup: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateDiscountGroup: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function discountGroupsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case DiscountGroupsTypes.UPDATE_DISCOUNT_GROUP_REQUEST: {
      return state.setIn(['updateDiscountGroup', 'isLoading'], true)
    }

    case DiscountGroupsTypes.UPDATE_DISCOUNT_GROUP_SUCCESS: {
      return state.setIn(['updateDiscountGroup', 'isLoading'], false)
    }

    case DiscountGroupsTypes.UPDATE_DISCOUNT_GROUP_FAILURE: {
      return state.setIn(['updateDiscountGroup', 'isLoading'], false)
    }

    case DiscountGroupsTypes.CREATE_DISCOUNT_GROUP_REQUEST: {
      return state.setIn(['createDiscountGroup', 'isLoading'], true)
    }

    case DiscountGroupsTypes.CREATE_DISCOUNT_GROUP_SUCCESS: {
      return state.setIn(['createDiscountGroup', 'isLoading'], false)
    }

    case DiscountGroupsTypes.CREATE_DISCOUNT_GROUP_FAILURE: {
      return state.setIn(['createDiscountGroup', 'isLoading'], false)
    }

    case DiscountGroupsTypes.DELETE_DISCOUNT_GROUP_REQUEST: {
      return state
    }

    case DiscountGroupsTypes.DELETE_DISCOUNT_GROUP_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case DiscountGroupsTypes.DELETE_DISCOUNT_GROUP_FAILURE: {
      return state
    }

    case DiscountGroupsTypes.FETCH_DISCOUNT_GROUPS_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case DiscountGroupsTypes.FETCH_DISCOUNT_GROUPS_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case DiscountGroupsTypes.FETCH_DISCOUNT_GROUPS_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case DiscountGroupsTypes.FETCH_DISCOUNT_GROUP_REQUEST: {
      return state.setIn(['updateDiscountGroup', 'isLoading'], true)
    }

    case DiscountGroupsTypes.FETCH_DISCOUNT_GROUP_SUCCESS: {
      return state
        .setIn(['updateDiscountGroup', 'isLoading'], false)
        .setIn(['updateDiscountGroup', 'data'], fromJS(action.payload))
    }

    case DiscountGroupsTypes.FETCH_DISCOUNT_GROUP_FAILURE: {
      return state.setIn(['updateDiscountGroup', 'isLoading'], false)
    }

    case DiscountGroupsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case DiscountGroupsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
